// @flow
import algoliasearch from "algoliasearch";
import _ from "lodash";
import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import CONFIG from "../config";
import { put, call, takeLatest } from "redux-saga/effects";

export default (api: Object) => {
  /* Get products */
  function* getProducts(action) {
    try {
      const response = yield call(api.products.getProducts, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getProductsSuccess(response.data));
        if (action.query && action.query.indexOf("details") === -1)
          yield put(Actions.getProductCount(action.query));
      } else {
        yield put(Actions.getProductsFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getProductsFailure(error));
    }
  }
  function* watchGetProducts(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PRODUCTS, getProducts);
  }

  /* Get products */
  function* getProductCount(action) {
    try {
      const response = yield call(api.products.getProductCount, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getProductCountSuccess(response.data));
      } else {
        yield put(Actions.getProductCountFailure());
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getProductCountFailure(error));
    }
  }
  function* watchGetProductCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PRODUCT_COUNT, getProductCount);
  }

  /* Search products */
  function* searchProducts(action) {
    const client = algoliasearch(CONFIG.ALGOLIA_APP_ID, CONFIG.ALGOLIA_APP_KEY);
    const index = client.initIndex("prod_products");
    try {
      // eslint-disable-next-line camelcase
      const response = yield index.search(action.params);
      if (_.isEmpty(response)) {
        yield put(Actions.searchProductsFailure("FAILED"));
      }
      yield put(Actions.searchProductsSuccess(response));
    } catch (error) {
      yield put(Actions.searchProductsFailure(error));
    }
  }
  function* watchSearchProducts(): Generator<void, void, void> {
    yield takeLatest(Types.SEARCH_PRODUCTS, searchProducts);
  }

  /* Post products */

  function* postProducts(action) {
    try {
      const response = yield call(api.products.postProducts, action.products);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.postProductsSuccess(response.data));
        toast(
          I18n.getText(
            "product.update-success",
            {},
            "Product Successfully Updated"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postProductsFailure(response.data.error));
        toast(
          response.data.error ||
            I18n.getText("product.update-error", {}, "Couldn't Update Offer"),
          {
            type: "error",
            className: "errorClass"
          }
        );
      }
    } catch (error) {
      yield put(Actions.postProductsFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchPostProducts(): Generator<void, void, void> {
    yield takeLatest(Types.POST_PRODUCTS, postProducts);
  }

  /* Export Offers */

  function* exportOffers(action) {
    try {
      const response = yield call(api.products.exportOffers, action.offers);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.exportOffersSuccess(response.data));
        fileDownload(response.data, "offers.csv");
        toast(
          I18n.getText(
            "product.export-success",
            {},
            "Offers Exported Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.exportOffersFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportOffersFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchExportOffers(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_OFFERS, exportOffers);
  }

  /* Export PSKU */

  function* exportPSku(action) {
    try {
      const response = yield call(api.products.exportPSku);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.exportPSkuSuccess(response.data));
        fileDownload(response.data, "partner-sku-unique.csv");
      } else {
        yield put(Actions.exportPSkuFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportPSkuFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchExportPSku(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_PSKU, exportPSku);
  }

  /* Activate products */

  function* activateOffers(action) {
    try {
      const response = yield call(api.products.activateOffers, action.products);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.activateOffersSuccess(response.data));
        if (action.query && action.query.indexOf("details") === -1)
          yield put(Actions.getProductCount(action.query));
        toast(
          I18n.getText(
            Number(action.products.activate)
              ? "product.activate-success"
              : "product.deactivate-success",
            {}
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.activateOffersFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.activateOffersFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchActivateOffers(): Generator<void, void, void> {
    yield takeLatest(Types.ACTIVATE_OFFERS, activateOffers);
  }

  /* Delete products */

  function* deleteOffers(action) {
    try {
      const response = yield call(api.products.deleteOffers, action.products);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.deleteOffersSuccess(response.data));
        if (action.query && action.query.indexOf("details") === -1)
          yield put(Actions.getProductCount(action.query));
        toast(
          I18n.getText(
            "product.offer-deleted",
            {},
            "Offer Deleted Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.deleteOffersFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.deleteOffersFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchDeleteOffers(): Generator<void, void, void> {
    yield takeLatest(Types.DELETE_OFFERS, deleteOffers);
  }

  /* Import offers */

  function* importOffers(action) {
    try {
      const response = yield call(api.products.importOffers, action.offers);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.importOffersSuccess(response.data));
      } else {
        yield put(Actions.importOffersFailure(response.data.error));
      }
    } catch (error) {
      yield put(Actions.importOffersFailure(error));
    }
  }
  function* watchImportOffers(): Generator<void, void, void> {
    yield takeLatest(Types.IMPORT_OFFERS, importOffers);
  }

  /* importPSkuUnique */

  function* importPSkuUnique(action) {
    try {
      const response = yield call(
        api.products.importPSkuUnique,
        action.pSkuUnique
      );
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.importPSkuUniqueSuccess(response.data));
        yield put(Actions.getAsnBatchesImport());
      } else {
        yield put(Actions.importPSkuUniqueFailure(response.data.error));
        toast(response.data.error || "Something went wrong", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.importPSkuUniqueFailure(error));
    }
  }
  function* watchImportPSkuUnique(): Generator<void, void, void> {
    yield takeLatest(Types.IMPORT_P_SKU_UNIQUE, importPSkuUnique);
  }

  return {
    watchGetProducts,
    watchSearchProducts,
    watchPostProducts,
    watchExportOffers,
    watchActivateOffers,
    watchDeleteOffers,
    watchImportOffers,
    watchImportPSkuUnique,
    watchExportPSku,
    watchGetProductCount
  };
};



// WEBPACK FOOTER //
// ./src/sagas/ProductsSaga.js